
export default function placeholder(getPlaceholder) {
  return (editor, root) => {

    function onDecorate(event) {
      const decorators = event.detail;
      if (decorators.contents.length() > 1 || decorators.contents.ops[0].attributes) return;
      const placeholder = getPlaceholder(editor, root);
      if (!placeholder) return;
      decorators.line(0, { placeholder });
    }

    function onPaste() {
      const firstBlock = root.firstElementChild;
      if (firstBlock && firstBlock.hasAttribute('placeholder')) {
        root.dispatchEvent(new Event('rendering'));
        firstBlock.removeAttribute('placeholder');
        root.dispatchEvent(new Event('render'));
      }
    }

    root.addEventListener('decorate', onDecorate);
    root.addEventListener('paste', onPaste);

    return {
      onDestroy() {
        root.removeEventListener('decorate', onDecorate);
        root.removeEventListener('paste', onPaste);
      }
    };
  };
}
